module.exports = "<div class=\"gw-tile-action__inside\" gw-partial=\"Item\"></div>\n"